import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
// @ts-expect-error This library is not yet typed
import { usePreviewAssociatedObjects } from 'customer-data-associations/hooks/usePreviewAssociatedObjects';
import H4 from 'UIComponents/elements/headings/H4';
import UIList from 'UIComponents/list/UIList';
import UIPopoverBody from 'UIComponents/tooltip/UIPopoverBody';
import UIPopoverHeader from 'UIComponents/tooltip/UIPopoverHeader';
import styled from 'styled-components';
import AssociationLink from './AssociationLink';
import UIPopoverFooter from 'UIComponents/tooltip/UIPopoverFooter';
import UIPaginator from 'UIComponents/paginator/UIPaginator';
import { useState } from 'react';
import LoadingCell from '../../LoadingCell';
import FormattedMessage from 'I18n/components/FormattedMessage';
const LinkWrapper = styled.div.withConfig({
  displayName: "AssociatedObjectsPopoverContent__LinkWrapper",
  componentId: "zd89ao-0"
})(["line-height:normal;"]);

const AssociatedObjectsPopoverContent = ({
  associationDefinition,
  numberOfAssociatedObjects,
  pageSize,
  objectId,
  onAssociationClick
}) => {
  const [pageNumber, setPageNumber] = useState(1);
  const {
    data,
    error,
    loading
  } = usePreviewAssociatedObjects({
    objectId,
    associationDefinition
  });

  if (loading) {
    // Show loading cells equal to the number of associations on the page
    const numberOfLoadingCells = Math.min(numberOfAssociatedObjects, pageSize); // For convenience

    const isLast = index => index === numberOfLoadingCells - 1;

    return /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(UIPopoverHeader, {
        children: /*#__PURE__*/_jsx(H4, {
          children: associationDefinition.label
        })
      }), /*#__PURE__*/_jsx(UIPopoverBody, {
        children: Array(numberOfLoadingCells).fill(0).map((_, index) => /*#__PURE__*/_jsx(LoadingCell, {
          className: isLast(index) ? '' : 'm-bottom-3'
        }, index))
      }), /*#__PURE__*/_jsx(UIPopoverFooter, {})]
    });
  }

  if (error) {
    return /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(UIPopoverHeader, {
        children: /*#__PURE__*/_jsx(H4, {
          children: associationDefinition.label
        })
      }), /*#__PURE__*/_jsx(UIPopoverBody, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "datatable.associationCell.error.resolver"
        })
      }), /*#__PURE__*/_jsx(UIPopoverFooter, {})]
    });
  }

  const offset = (pageNumber - 1) * pageSize;
  const numberOfPages = Math.ceil(data.length / pageSize);
  const objectsOnPage = data.slice(offset, offset + pageSize);
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(UIPopoverHeader, {
      children: /*#__PURE__*/_jsx(H4, {
        children: associationDefinition.label
      })
    }), /*#__PURE__*/_jsx(UIPopoverBody, {
      children: /*#__PURE__*/_jsx(UIList, {
        childClassName: "m-top-1",
        firstChildClassName: "",
        children: objectsOnPage.map(object => /*#__PURE__*/_jsx(LinkWrapper, {
          children: /*#__PURE__*/_jsx(AssociationLink, {
            associationDefinition: associationDefinition,
            object: object,
            onAssociationClick: onAssociationClick
          })
        }, object.objectId))
      })
    }), /*#__PURE__*/_jsx(UIPopoverFooter, {
      children: numberOfPages > 1 && /*#__PURE__*/_jsx(UIPaginator, {
        maxVisiblePageButtons: 0,
        onPageChange: ({
          target: {
            value
          }
        }) => setPageNumber(value),
        pageCount: numberOfPages
      })
    })]
  });
};

export default AssociatedObjectsPopoverContent;